'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'database';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f1c0';
var svgPathData = 'M400 86l0 88.7c-13.3 7.2-31.6 14.2-54.8 19.9-34 8.4-75.7 13.4-121.2 13.4s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7l0-88.7 .6-.5C53.9 81 64.5 74.8 81.8 68.6 115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6 .5zM400 426l-.6 .5c-5.3 4.5-15.9 10.7-33.2 16.9-34.1 12.2-84.4 20.6-142.2 20.6s-108.1-8.5-142.2-20.6c-17.3-6.2-27.8-12.4-33.2-16.9l-.6-.5 0-70.4c13.3 5.3 27.9 9.9 43.3 13.7 38.2 9.4 83.9 14.8 132.7 14.8s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7l0 70.4zm0-123.3c-13.3 7.2-31.6 14.2-54.8 19.9-34 8.4-75.7 13.4-121.2 13.4s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7l0-75.2c13.3 5.3 27.9 9.9 43.3 13.7 38.2 9.4 83.9 14.8 132.7 14.8s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7l0 75.2zM448 432l0-352C448 35.8 347.7 0 224 0S0 35.8 0 80L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDatabase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;